import { AppType } from '@/core/types/AppType';
import { AppEnvironment } from '@/core/types/AppEnvironment';

export const APP_DOMAINS: Record<AppType, Record<AppEnvironment, string>> = {
  app: {
    prod: 'https://app.mellow.finance',
    staging: 'https://app.stage.mellow.finance',
    dev: 'http://localhost:3000',
  },
  curation: {
    prod: 'https://curation.mellow.finance',
    staging: 'https://curation.stage.mellow.finance',
    dev: 'http://localhost:3000',
  },
  landing: {
    prod: 'https://mellow.finance',
    staging: 'https://landing.stage.mellow.finance',
    dev: 'http://localhost:3000',
  },
};
